import React from "react";
import { Toaster } from "./ui/sonner";
import { MarketingFooter, MarketingHeader } from "./MarketingChrome";
import { Bim3DContactSection } from "./bim3d/Bim3DContactSection";
import { Bim3DEstimatorSection } from "./bim3d/Bim3DEstimatorSection";
import { Bim3DHeroSection } from "./bim3d/Bim3DHeroSection";

export default function Bim3DSynthesePage() {
  return (
    <div className="relative overflow-hidden bg-[radial-gradient(circle_at_top,_rgba(190,242,100,0.14),_transparent_24%),linear-gradient(180deg,_#fbfdf8_0%,_#f8fcf3_44%,_#ffffff_100%)]" data-testid="bim3d-page">
      <MarketingHeader />
      <main>
        <Bim3DHeroSection />
        <Bim3DEstimatorSection />
        <Bim3DContactSection />
      </main>
      <MarketingFooter />
      <Toaster closeButton position="top-center" />
    </div>
  );
}